module.exports = __webpack_public_path__ + "static/media/buddha-banner.fb7a7aa4.png";